/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
const MESSAGES = {
  SUBENTERPRISE_EMPTY_SCREEN_TITLE: "No account to display",
  SUBENTERPRISE_ADD_BUTTON: "Add account",
  NO_RESULTS_FOUND: "No results found",
  PLEASE_TRY_A_DIFFERENT_SUBENTERPRISE: "Please Try a Different account",
  SUBENTERPRISE_TITLE: "Account",
  COPIED_TO_CLIPBOARD: "Copied to clipboard",
  SELECT_SUBENTERPRISE: "Select account",
  NO_SUBENTERPRISE_SELECTED: "No account selected",
};

const TITLES = {
  EDIT: "Edit",
  CLONE: "Clone",
  DELETE: "Delete",
  REALMS: "Realms",
  COST_CENTER: "Cost Center :",
  ENTITLEMENTS: "Entitlements",
  ACCOUNT_ID: "Account Id:",
  ACCOUNT_KEY: "Account Key:",
  SUBENTERPRISE_NAME: "Account Name",
};

export { MESSAGES, TITLES };
